import { getFormattedDateTime } from "utils/format";

// `next.config.js` exposes the closure date through its `env` block; Next
// inlines that value at build time, so this is not a runtime OS env lookup.
// The fallback keeps unit tests working where next.config.js is not loaded.
export const PREORDER_CLOSURE_DATE =
  process.env.preorder_closure_date || "2026-11-19T23:59:59Z";

// UTC and GMT are the same offset; the deadline is in November (no BST), so
// this matches the "GMT" wording in the banner.
export const PREORDER_TIME_ZONE = "UTC";

export function calculateTimeLeft(targetDate) {
  const diff = new Date(targetDate).getTime() - Date.now();

  if (Number.isNaN(diff) || diff <= 0) return null;

  const totalMinutes = Math.floor(diff / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  let minutes = totalMinutes % 60;

  // Keep the final minute readable as "1 minute" instead of "0 minutes".
  if (days === 0 && hours === 0 && minutes === 0) minutes = 1;

  return { days, hours, minutes };
}

export function getClosureLabels(locale) {
  return getFormattedDateTime(
    PREORDER_CLOSURE_DATE,
    locale,
    PREORDER_TIME_ZONE,
  );
}
